import React from "react";
import moment from "moment";
import { ReportName } from "types/gql-types";
import { ReportTable } from "./report-table";

const parseDate = (date: string) => {
  if (date === "") {
    return "N/A";
  }
  return moment(date).fromNow();
};

export const UserStats: React.FC = () => (
  <ReportTable
    reportName={ReportName.USER_STATS}
    includeTitle
    hideDateFilter
    processRow={
      (
        [
          name,
          email,
          lastLogin,
          property,
          lastComm,
          lastChannel,
        ],
      ) => [name, email, parseDate(lastLogin), property, parseDate(lastComm), lastChannel]}
  />
);
